import React from "react";
import styled from "styled-components";
import moment from "moment";
import { colors } from "@sonder/ui/source/styled/theme";

const Text = styled.div<{ hasDueDate: boolean }>`
  color: ${props => (props.hasDueDate ? colors.gray1 : colors.gray6)};
  font-weight: 400;
`;

interface SearchCardDueAtProps {
  className?: string;
  dueAt: string | null;
}

export const SearchCardDueAt = ({ className, dueAt }: SearchCardDueAtProps) => {
  const formattedDueAt = dueAt ? moment(dueAt).format("MMM D") : "No Due Date";

  return (
    <Text className={className} hasDueDate={!!dueAt}>
      {formattedDueAt}
    </Text>
  );
};
